import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿De verdad es gratis?',
    a: 'Sí. La guía se entrega sin costo por WhatsApp.'
  }, {
    q: '¿Por qué mencionan $17?',
    a: 'Porque es el valor de referencia que antes tenía como producto. Hoy se entrega como bono gratuito.'
  }, {
    q: '¿Me puedes orientar por WhatsApp?',
    a: 'Sí. Puedes escribirme y te responderé lo antes posible.'
  }, {
    q: '¿Los precios del seguro son iguales para todos?',
    a: 'No. Dependen de edad, salud, estado y el tipo de cobertura.'
  }, {
    q: '¿Esto reemplaza asesoría legal o fiscal?',
    a: 'No. Es contenido educativo. Para temas legales/fiscales, consulta un profesional.'
  }];
  return <section className="bg-cream py-20 px-6" data-id="element-30">
      <div className="max-w-3xl mx-auto" data-id="element-31">
        <div className="text-center mb-12" data-id="element-32">
          <h2 className="font-heading text-3xl md:text-4xl text-navy font-bold" data-id="element-33">
            Preguntas frecuentes
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto mt-4 rounded-full" data-id="element-34" />
        </div>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-36" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-2xl shadow-sm border border-navy/5 overflow-hidden" data-id="element-37">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-expanded={isOpen} data-id="element-38">
        <span className="font-bold text-navy text-lg pr-4" data-id="element-39">{question}</span>
        <ChevronDownIcon className={`w-5 h-5 text-gold flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-40" />
      </button>
      <AnimatePresence data-id="element-41">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-42">
            <div className="px-6 pb-5 text-gray-600 border-t border-gray-100 pt-3" data-id="element-43">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}